import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Invoice } from '@teem/models/invoice';
import { InvoiceDeliverable } from '@teem/models/invoice-deliverable';
import { InvoiceDeliverableForm } from '@teem/model-forms/invoice-deliverable-form';

export class InvoiceForm {
  uuid = new FormControl();
  invoice_type = new FormControl('b2c', [Validators.required]);
  title = new FormControl('');
  currency = new FormControl('SAR');
  invoice_number = new FormControl('', [Validators.required]);
  parent_invoice_id = new FormControl('');
  invoice_date = new FormControl('', [Validators.required]);
  invoice_time = new FormControl('');
  client_id = new FormControl('', [Validators.required]);
  total_amount = new FormControl(0);
  is_draft = new FormControl(0);
  project_type = new FormControl(null, [Validators.required]);
  include_tax = new FormControl(false);
  tax_percent = new FormControl(null, [Validators.required,Validators.min(0),Validators.max(100)]);
  discount_type = new FormControl('percentage');
  discount =  new FormControl(null, [Validators.min(0),Validators.max(100)]);
  delivery_fee =  new FormControl(null);
  original_amount = new FormControl(null);
  discounted_amount = new FormControl(null);
  payment_info = new FormGroup({
    name: new FormControl(''),
    iban: new FormControl(''),
    account_number: new FormControl(''),
    bank_name: new FormControl(''),
    country: new FormControl('')
  });
  additional_info = new FormControl();
  online_payment_percent = new FormControl();
  items = new FormArray([]);
  include_payment_info = new FormControl(false);
  include_additional_info = new FormControl(false);
  include_online_payment = new FormControl(false);
  save_default_payment_info = new FormControl(false);
  save_default_additional_info = new FormControl(false);
  tax_type = new FormControl(2);
  action = new FormControl(null);

  buyer_first_name = new FormControl(null);
  buyer_last_name = new FormControl(null);
  buyer_address = new FormControl(null);
  buyer_vat_number = new FormControl(null);
  buyer_cr_number = new FormControl(null);

  constructor(invoice: Invoice) {

    if (invoice) {
      this.invoice_type.setValue(invoice.invoice_type);
      this.title.setValue(invoice.title);
      this.currency.setValue(invoice.currency);
      this.invoice_number.setValue(invoice.invoice_number);
      this.parent_invoice_id.setValue(invoice.parent_invoice_id);
      this.invoice_date.setValue(invoice.invoice_date);
      this.invoice_time.setValue(invoice.invoice_time);
      this.client_id.setValue(invoice.client_id);
      this.total_amount.setValue(invoice.total_amount);
      this.project_type.setValue(invoice.project_type);
      this.include_tax.setValue(invoice.include_tax);
      this.tax_type.setValue(invoice.tax_type);
      this.additional_info.setValue(invoice.additional_info);
      this.discount_type.setValue(invoice.discount_type);
      this.discount.setValue(invoice.discount);
      this.delivery_fee.setValue(invoice.delivery_fee);
      this.original_amount.setValue(invoice.original_amount);
      this.discounted_amount.setValue(invoice.discounted_amount);

      this.buyer_first_name.setValue(invoice.buyer_first_name);
			this.buyer_last_name.setValue(invoice.buyer_last_name);
			this.buyer_address.setValue(invoice.buyer_address);
			this.buyer_vat_number.setValue(invoice.buyer_vat_number);
			this.buyer_cr_number.setValue(invoice.buyer_cr_number);

      if (invoice.payment_info) {
        this.payment_info.setValue(invoice.payment_info);
        this.include_payment_info.setValue(true);
      }

      if (invoice.additional_info) {
        this.include_additional_info.setValue(true);
      }

      if (invoice.tax_percent) {
        this.include_tax.setValue(true)
        this.tax_percent.setValue(invoice.tax_percent)
      }

      if (invoice.items && invoice.items.length) {
        let fb = new FormBuilder();
        invoice.items.forEach((item) => {
          this.items.push(
            fb.group(new InvoiceDeliverableForm(new InvoiceDeliverable(item)))
          )
        })
      }
    }
  }
}
